import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getReportsStatisticsRequest } from "../../services/reportsStatisticsServices";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getReportsStatistics({
  organizationId,
  restaurantId,
  startDate,
  endDate,
}) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getReportsStatisticsRequest,
      organizationId,
      restaurantId,
      startDate,
      endDate,
      token
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_REPORTS_STATISTICS_SUCCESS,
        reportsStatistics: response[1],
        loadingReportsStatistics: false,
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(
      actions.GET_REPORTS_STATISTICS_REQUEST,
      getReportsStatistics
    ),
  ]);
}
